import React, { useState, useEffect } from "react";
import { useOrganisations } from "../Auth/useOrganisations";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMenus, getMenusreadyToServe } from "../Services/MenuApi";
import {
  createAchat,
  getAchats,
  getFournisseurs,
  getLastPurchasePrice,
  validateAchat,
  getAchatById,
  updateAchat,
  createFournisseur,
  generateFacture,
  generateFacturePDF,
  getPaymentsByAchat,
} from "../Services/AchatApi";
import { useUser } from "../Auth/useUser";
import { formatDateAndTime } from "../Helpers/Helpers";
import Swal from "sweetalert2";
import moment from "moment/moment";
import PaymentModal from "../Components/PaymentModal";
import SupplierStatement from "../Components/SupplierStatement";
import { useNavigate } from "react-router-dom";
import ProductSelector from "../Components/Caisse/ProductSelector";
// Unit options for the purchase form
const UNIT_OPTIONS = [
  { value: "pcs", label: "Pièce (pcs)" },
  { value: "kg", label: "Kilogramme (kg)" },
  { value: "L", label: "Litre (L)" },
  { value: "m²", label: "Mètre carré (m²)" },
];

// const defaultFactorForUnit = (unitValue) => {
//   const found = UNIT_OPTIONS.find((u) => u.value === unitValue);
//   return found ? found.factor : 1;
// };
// Modal component for adding new purchase
const AddAchatModal = ({
  isOpen,
  onClose,
  onSuccess,
  editingAchat,
  onEditSuccess,
}) => {
  const user = useUser();
  const infoUser = user.result;
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);
  const [fournisseurSearch, setFournisseurSearch] = useState("");
  const [fournisseurList, setFournisseurList] = useState([]);
  const [isLoadingFournisseurs, setIsLoadingFournisseurs] = useState(false);
  const [showFournisseurDropdown, setShowFournisseurDropdown] = useState(false);
  const [showSupplierForm, setShowSupplierForm] = useState(false);
  const [numeroFacture, setNumeroFacture] = useState("");

  const [dateAchat, setDateAchat] = useState(
    new Date(), // Today's date as default
  );
  const [newFournisseurDetails, setNewFournisseurDetails] = useState({
    telephone: "",
    email: "",
    adresse: "",
    contact: "",
    siret: "",
    // New fields
    matricule_fiscal: "",
    registre_commerce: "",
    numero_tva: "",
    rib: "",
    iban: "",
    bic: "",
    nom_banque: "",
    conditions_paiement: "comptant",
    delai_paiement: 0,
  });

  const [mode_paiement, setModePaiement] = useState("espece");
  const [notes, setNotes] = useState("");
  const [type_achat, setTypeAchat] = useState("stock");
  const [statut, setStatut] = useState("recu");
  const [produits, setProduits] = useState([
    {
      menu_id: "",
      menu_name: "",
      quantite: 1,
      unite: "pcs",
      prix_unitaire_ht: 0,
      taux_tva: 19,
      menu_reference: "",
    },
  ]);
  const [organisations, , usedOrganisations] = useOrganisations();

  useEffect(() => {
    if (isOpen) {
      loadFournisseurs("");

      // If editing an achat, load its data
      if (editingAchat) {
        loadAchatForEditing(editingAchat);
      } else {
        // Reset form for new achat
        resetForm();
      }
    }
  }, [isOpen, usedOrganisations, editingAchat]);

  const loadAchatForEditing = async (achatId) => {
    try {
      const response = await getAchatById(achatId);
      if (response.data.success) {
        const achat = response.data.data;

        // Set form fields with achat data
        setNumeroFacture(achat.numero_facture || "");
        setDateAchat(
          achat.date_achat
            ? new Date(achat.date_achat).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0],
        );
        setStatut(achat.statut || "recu");
        setModePaiement(achat.mode_paiement || "espece");
        setNotes(achat.notes || "");
        setTypeAchat(achat.type_achat || "stock");

        // Set fournisseur
        if (achat.fournisseur_details) {
          setSelectedFournisseur(achat.fournisseur_details);
          setFournisseurSearch(achat.fournisseur_details.nom || "");
        }

        // Set produits
        if (achat.produits && achat.produits.length > 0) {
          const formattedProduits = achat.produits.map((produit) => {
            const unite = produit.unite || produit.menu_details?.unite || "pcs";
            const prixHT = produit.prix_unitaire_ht || 0;
            const taux = produit.taux_tva || 19;
            const qte = produit.quantite || 1;
            return {
              menu_id: produit.menu_id,
              menu_name:
                produit.menu_details?.titre?.fr ||
                produit.menu_details?.titre ||
                "",
              show_menu_dropdown: false,
              menu_reference: produit.menu_details?.reference || "",

              quantite: qte,
              unite: unite,
              prix_unitaire_ht: prixHT,
              taux_tva: taux,
              total_ht: parseFloat((prixHT * qte).toFixed(3)),
              total_ttc: parseFloat(
                (prixHT * (1 + taux / 100) * qte).toFixed(3),
              ),
              show_menu_dropdown: false,
            };
          });
          setProduits(formattedProduits);
        }
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des détails de l'achat");
      onClose();
    }
  };

  const resetForm = () => {
    setSelectedFournisseur(null);
    setFournisseurSearch("");
    setFournisseurList([]);
    setNumeroFacture("");
    setDateAchat(new Date().toISOString().split("T")[0]);
    setStatut("recu");
    setModePaiement("espece");
    setNotes("");
    setTypeAchat("stock");
    setProduits([
      {
        menu_id: "",
        menu_name: "",
        quantite: 1,
        unite: "pcs",
        prix_unitaire_ht: 0,
        taux_tva: 19,
        menu_reference: "",
      },
    ]);
  };

  const loadFournisseurs = async (searchTerm = "") => {
    if (!usedOrganisations) return;

    setIsLoadingFournisseurs(true);
    try {
      const response = await getFournisseurs(usedOrganisations, searchTerm);
      if (response.data.success) {
        setFournisseurList(response.data.data || []);
      }
    } catch (error) {
      console.error("Error loading suppliers:", error);
      toast.error("Erreur lors du chargement des fournisseurs");
    } finally {
      setIsLoadingFournisseurs(false);
    }
  };

  // Search handler with debounce
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (fournisseurSearch.trim()) {
        loadFournisseurs(fournisseurSearch);
      } else {
        loadFournisseurs("");
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [fournisseurSearch, usedOrganisations]);

  useEffect(() => {
    const handleClickOutsideFournisseur = (event) => {
      const fournisseurInput = document.querySelector(
        'input[placeholder*="fournisseur"]',
      );
      const fournisseurDropdown = document.querySelector(
        ".fournisseur-dropdown",
      );

      if (
        showFournisseurDropdown &&
        fournisseurInput &&
        fournisseurDropdown &&
        !fournisseurInput.contains(event.target) &&
        !fournisseurDropdown.contains(event.target)
      ) {
        setShowFournisseurDropdown(false);
      }
    };

    if (showFournisseurDropdown) {
      document.addEventListener("mousedown", handleClickOutsideFournisseur);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideFournisseur);
    };
  }, [showFournisseurDropdown]);

  // Handle click outside for product dropdowns

  const handleSelectFournisseur = (fournisseur) => {
    setSelectedFournisseur(fournisseur);
    setFournisseurSearch(fournisseur.nom);
    setShowFournisseurDropdown(false);
  };

  const handleClearFournisseur = () => {
    setSelectedFournisseur(null);
    setFournisseurSearch("");
    setShowFournisseurDropdown(false);
  };

  const handleAddNewFournisseur = () => {
    setShowSupplierForm(true);
  };

  const handleSaveNewSupplier = async () => {
    if (!fournisseurSearch.trim()) {
      toast.error("Le nom du fournisseur est obligatoire");
      return;
    }

    // Prepare supplier data for backend
    const supplierData = {
      organisation_id: usedOrganisations,
      nom: fournisseurSearch,
      telephone: newFournisseurDetails.telephone || "",
      email: newFournisseurDetails.email || "",
      adresse: newFournisseurDetails.adresse || "",
      contact: newFournisseurDetails.contact || "",
      siret: newFournisseurDetails.siret || "",
      // Tunisian fiscal fields
      matricule_fiscal: newFournisseurDetails.matricule_fiscal || "",
      registre_commerce: newFournisseurDetails.registre_commerce || "",
      numero_tva: newFournisseurDetails.numero_tva || "",
      // Bank details
      banque: {
        rib: newFournisseurDetails.rib || "",
        iban: newFournisseurDetails.iban || "",
        bic: newFournisseurDetails.bic || "",
        nom_banque: newFournisseurDetails.nom_banque || "",
      },
      // Payment terms
      conditions_paiement:
        newFournisseurDetails.conditions_paiement || "comptant",
      delai_paiement: parseInt(newFournisseurDetails.delai_paiement) || 0,
      created_by: infoUser.id,
    };

    try {
      // Show loading state
      toast.info("Création du fournisseur en cours...");

      // Call API to create supplier
      const response = await createFournisseur(supplierData);

      if (response.data.success) {
        // Get the created supplier with its ID
        const createdSupplier = {
          id: response.data.data.id || response.data.data._id,
          nom: supplierData.nom,
          telephone: supplierData.telephone,
          email: supplierData.email,
          adresse: supplierData.adresse,
          contact: supplierData.contact,
          siret: supplierData.siret,
          matricule_fiscal: supplierData.matricule_fiscal,
          registre_commerce: supplierData.registre_commerce,
          numero_tva: supplierData.numero_tva,
          conditions_paiement: supplierData.conditions_paiement,
          delai_paiement: supplierData.delai_paiement,
        };

        setSelectedFournisseur(createdSupplier);
        setShowSupplierForm(false);
        setShowFournisseurDropdown(false);

        // Reset the form
        setNewFournisseurDetails({
          telephone: "",
          email: "",
          adresse: "",
          contact: "",
          siret: "",
          matricule_fiscal: "",
          registre_commerce: "",
          numero_tva: "",
          rib: "",
          iban: "",
          bic: "",
          nom_banque: "",
          conditions_paiement: "comptant",
          delai_paiement: 0,
        });

        toast.success("Fournisseur créé avec succès");

        // Refresh the supplier list
        loadFournisseurs("");
      }
    } catch (error) {
      console.error("Error creating supplier:", error);
      toast.error(
        error.response?.data?.message ||
          "Erreur lors de la création du fournisseur",
      );
    }
  };

  const handleSupplierDetailChange = (field, value) => {
    setNewFournisseurDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancelSupplierForm = () => {
    setShowSupplierForm(false);
    setFournisseurSearch("");
  };

  const handleFournisseurSearchChange = (e) => {
    const value = e.target.value;
    setFournisseurSearch(value);

    if (value.trim()) {
      setShowFournisseurDropdown(true);
    } else {
      setShowFournisseurDropdown(false);
    }

    if (!value.trim() && selectedFournisseur) {
      setSelectedFournisseur(null);
    }
  };

  const handleProduitChange = (index, field, value) => {
    const updatedProduits = [...produits];

    if (field === "total_ttc") {
      // When TTC is changed, calculate HT and TVA
      const ttcValue = parseFloat(value) || 0;
      const taux = parseFloat(updatedProduits[index].taux_tva) || 0;
      const quantite = parseFloat(updatedProduits[index].quantite) || 1;

      if (taux > 0) {
        // Calculate HT from TTC: HT = TTC / (1 + TVA%)
        const totalHT = ttcValue / (1 + taux / 100);
        const prixUnitaireHT = totalHT / quantite;

        updatedProduits[index].total_ttc = ttcValue.toFixed(3);
        updatedProduits[index].total_ht = totalHT.toFixed(3);
        updatedProduits[index].prix_unitaire_ht = prixUnitaireHT.toFixed(3);
        updatedProduits[index].prix_unitaire_ttc = (
          ttcValue / quantite
        ).toFixed(3);
      } else {
        // If TVA is 0%, HT = TTC
        const prixUnitaireHT = ttcValue / quantite;

        updatedProduits[index].total_ttc = ttcValue.toFixed(3);
        updatedProduits[index].total_ht = ttcValue.toFixed(3);
        updatedProduits[index].prix_unitaire_ht = prixUnitaireHT.toFixed(3);
        updatedProduits[index].prix_unitaire_ttc = (
          ttcValue / quantite
        ).toFixed(3);
      }
    } else if (field === "unite") {
      updatedProduits[index].unite = value;
    } else {
      updatedProduits[index][field] = value;
    }

    // Recalculate totals when HT, TVA, or quantity changes
    if (
      field === "prix_unitaire_ht" ||
      field === "taux_tva" ||
      field === "quantite"
    ) {
      const prixHT = parseFloat(updatedProduits[index].prix_unitaire_ht) || 0;
      const taux = parseFloat(updatedProduits[index].taux_tva) || 0;
      const quantite = parseFloat(updatedProduits[index].quantite) || 1;

      updatedProduits[index].prix_unitaire_ttc = (
        prixHT *
        (1 + taux / 100)
      ).toFixed(3);
      updatedProduits[index].total_ht = (prixHT * quantite).toFixed(3);
      updatedProduits[index].total_ttc = (
        updatedProduits[index].prix_unitaire_ttc * quantite
      ).toFixed(3);
    }

    setProduits(updatedProduits);
  };

  const handleSelectProduct = async (index, menu) => {
    const updatedProduits = [...produits];
    updatedProduits[index].menu_id = menu.id || menu._id;
    updatedProduits[index].menu_name = menu.titre?.fr || menu.titre || "";
    updatedProduits[index].menu_reference = menu.reference || "";

    let prixHT = menu.prix_achat || 0;

    // Pre-fill unit from the product's own definition
    if (menu.unite) {
      updatedProduits[index].unite = menu.unite;
    }

    try {
      const response = await getLastPurchasePrice(menu.id || menu._id);
      if (response.data.success && response.data.data.last_price) {
        prixHT = response.data.data.last_price;
        // Restore the unit that was used in the last purchase (overrides product default)
        if (response.data.data.unite) {
          updatedProduits[index].unite = response.data.data.unite;
        }
      } else if (menu.prix_achat) {
        toast.info(
          `Prix par défaut du produit utilisé: ${menu.prix_achat.toFixed(3)}`,
        );
      }
    } catch (error) {
      console.error("Error fetching last purchase price:", error);
      if (menu.prix_achat) {
        prixHT = menu.prix_achat;
        toast.info(`Prix par défaut utilisé: ${menu.prix_achat.toFixed(3)}`);
      }
    }

    updatedProduits[index].prix_unitaire_ht = prixHT;

    const taux = parseFloat(updatedProduits[index].taux_tva) || 0;
    const quantite = parseFloat(updatedProduits[index].quantite) || 1;

    updatedProduits[index].prix_unitaire_ttc = prixHT * (1 + taux / 100);
    updatedProduits[index].total_ht = prixHT * quantite;
    updatedProduits[index].total_ttc =
      updatedProduits[index].prix_unitaire_ttc * quantite;

    setProduits(updatedProduits);
  };

  const handleClearProduct = (index) => {
    const updatedProduits = [...produits];
    updatedProduits[index].menu_id = "";
    updatedProduits[index].menu_name = "";
    updatedProduits[index].menu_reference = "";
    updatedProduits[index].prix_unitaire_ht = 0;
    updatedProduits[index].total_ht = 0;
    updatedProduits[index].total_ttc = 0;
    setProduits(updatedProduits);
  };

  // Bridges ProductSelector's onProductSelect(product|null) callback to the
  // existing handleSelectProduct/handleClearProduct logic, and prevents
  // picking a product that's already used on another line.
  const handleProductSelectorChange = (index, product) => {
    if (!product) {
      handleClearProduct(index);
      return;
    }

    const productId = product.id || product._id;
    const alreadyUsedElsewhere = produits.some(
      (p, i) => i !== index && p.menu_id === productId,
    );

    if (alreadyUsedElsewhere) {
      toast.error("Ce produit est déjà sélectionné dans une autre ligne");
      return;
    }

    handleSelectProduct(index, product);
  };

  const addProduit = () => {
    setProduits([
      ...produits,
      {
        menu_id: "",
        menu_name: "",
        quantite: 1,
        unite: "pcs",
        prix_unitaire_ht: 0,
        taux_tva: 20,
        menu_reference: "",
      },
    ]);
  };

  const removeProduit = (index) => {
    if (produits.length > 1) {
      const updatedProduits = produits.filter((_, i) => i !== index);
      setProduits(updatedProduits);
    }
  };

  const calculateTotals = () => {
    console.log(produits);
    const totalHT = produits.reduce(
      (sum, p) => sum + (parseFloat(p.total_ht) || 0),
      0,
    );
    const totalTVA = produits.reduce((sum, p) => {
      return (
        sum + ((parseFloat(p.total_ttc) || 0) - (parseFloat(p.total_ht) || 0))
      );
    }, 0);
    const totalTTC = produits.reduce(
      (sum, p) => sum + (parseFloat(p.total_ttc) || 0),
      0,
    );

    return { totalHT, totalTVA, totalTTC };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFournisseur || !selectedFournisseur.nom.trim()) {
      toast.error("Le nom du fournisseur est obligatoire");
      return;
    }

    for (const produit of produits) {
      if (!produit.menu_id) {
        toast.error("Veuillez sélectionner un produit pour chaque ligne");
        return;
      }
      if (!produit.quantite || parseFloat(produit.quantite) <= 0) {
        toast.error("La quantité doit être supérieure à 0");
        return;
      }
      if (!produit.prix_unitaire_ht || produit.prix_unitaire_ht <= 0) {
        toast.error("Le prix unitaire doit être supérieur à 0");
        return;
      }
    }

    const { totalHT, totalTVA, totalTTC } = calculateTotals();

    const fournisseurData = {
      nom: selectedFournisseur.nom,
      contact: selectedFournisseur.contact || "",
      email: selectedFournisseur.email || "",
      telephone: selectedFournisseur.telephone || "",
      adresse: selectedFournisseur.adresse || "",
      siret: selectedFournisseur.siret || "",
      ...(selectedFournisseur.id !== "new" && { id: selectedFournisseur.id }),
    };
    console.log("produits   ffffffffff", produits);
    const achatData = {
      fournisseur: fournisseurData,
      date_achat: dateAchat,
      numero_facture: numeroFacture,
      produits: produits?.map((p) => ({
        menu_id: p.menu_id,
        quantite: parseFloat(p.quantite), // parseFloat keeps 1.5 kg intact
        prix_unitaire_ht: parseFloat(p.prix_unitaire_ht),
        taux_tva: parseFloat(p.taux_tva),
        total_ttc: parseFloat(p.total_ttc),
        unite: p.unite || "pcs", // e.g. "kg"
      })),
      total_ht: totalHT,
      total_tva: totalTVA,
      total_ttc: totalTTC,
      type_achat,
      statut,
      mode_paiement,
      notes,
      organisation_id: usedOrganisations,
      created_by: infoUser.id,
    };
    console.log("Submitting achat data:", {
      editingAchat,
      achatData,
      produits: achatData.produits,
    });
    try {
      let response;

      if (editingAchat) {
        // Update existing achat
        console.log("Updating achat:", editingAchat);
        response = await updateAchat(editingAchat, achatData);
        console.log("Update response:", response.data);
        if (response.data.success) {
          onSuccess(response.data);

          toast.success("Achat mis à jour avec succès");
          onClose();
        }
      } else {
        // Create new achat
        response = await createAchat(achatData);
        if (response.data.success) {
          toast.success("Achat créé avec succès");
          if (response.data.data.message) {
            toast.info(response.data.data.message);
          }
          onSuccess(response.data.data.achat);
          onClose();
        }
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          (editingAchat
            ? "Erreur lors de la mise à jour de l'achat"
            : "Erreur lors de la création de l'achat"),
      );
    }
  };

  const { totalHT, totalTVA, totalTTC } = calculateTotals();

  if (!isOpen) return null;

  return (
    <>
      {/* Main Purchase Modal */}
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editingAchat ? "Modifier l'Achat" : "Nouvel Achat"}
              </h5>
              <button type="button" className="close" onClick={onClose}>
                <span>&times;</span>
              </button>
            </div>
            <div
              className="modal-body p-20"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <h5>Fournisseur</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div style={{ position: "relative" }}>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control mt-0"
                                placeholder="Rechercher un fournisseur..."
                                value={fournisseurSearch}
                                onChange={handleFournisseurSearchChange}
                                onFocus={() => setShowFournisseurDropdown(true)}
                                required
                              />
                              <div className="input-group-append">
                                {selectedFournisseur ? (
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={handleClearFournisseur}
                                    title="Effacer la sélection"
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={handleAddNewFournisseur}
                                    // disabled={!fournisseurSearch}
                                    title="Créer un nouveau fournisseur"
                                  >
                                    <i className="fa fa-plus"></i>
                                  </button>
                                )}
                              </div>
                            </div>{" "}
                            {showSupplierForm === true ? (
                              <div className="card mt-3 border-primary">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                  <strong>Nouveau fournisseur</strong>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-light"
                                    onClick={handleCancelSupplierForm}
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                </div>

                                <div className="card-body">
                                  <div className="form-group">
                                    <label>Nom du fournisseur *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={fournisseurSearch}
                                      onChange={(e) =>
                                        setFournisseurSearch(e.target.value)
                                      }
                                      required
                                    />
                                  </div>

                                  {/* Tunisian Fiscal Information */}
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Matricule Fiscal</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.matricule_fiscal ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "matricule_fiscal",
                                              e.target.value,
                                            )
                                          }
                                          placeholder="1234567X/A/M/000"
                                        />
                                        <small className="text-muted">
                                          Format Tunisien
                                        </small>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Registre de Commerce (RC)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.registre_commerce ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "registre_commerce",
                                              e.target.value,
                                            )
                                          }
                                          placeholder="B1234567890"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Numéro TVA</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.numero_tva ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "numero_tva",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>SIRET (optionnel)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={newFournisseurDetails.siret}
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "siret",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <label>Contact</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={newFournisseurDetails.contact}
                                      onChange={(e) =>
                                        handleSupplierDetailChange(
                                          "contact",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Téléphone</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.telephone
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "telephone",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Email</label>
                                        <input
                                          type="email"
                                          className="form-control"
                                          value={newFournisseurDetails.email}
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "email",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <label>Adresse</label>
                                    <textarea
                                      className="form-control"
                                      rows="2"
                                      value={newFournisseurDetails.adresse}
                                      onChange={(e) =>
                                        handleSupplierDetailChange(
                                          "adresse",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>

                                  {/* Bank Details */}
                                  <div className="card mt-3">
                                    <div className="card-header bg-light">
                                      <strong>Coordonnées Bancaires</strong>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>RIB</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={
                                                newFournisseurDetails.rib || ""
                                              }
                                              onChange={(e) =>
                                                handleSupplierDetailChange(
                                                  "rib",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>IBAN</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={
                                                newFournisseurDetails.iban || ""
                                              }
                                              onChange={(e) =>
                                                handleSupplierDetailChange(
                                                  "iban",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>BIC/SWIFT</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={
                                                newFournisseurDetails.bic || ""
                                              }
                                              onChange={(e) =>
                                                handleSupplierDetailChange(
                                                  "bic",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>Nom de la banque</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={
                                                newFournisseurDetails.nom_banque ||
                                                ""
                                              }
                                              onChange={(e) =>
                                                handleSupplierDetailChange(
                                                  "nom_banque",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Payment Terms */}
                                  <div className="row mt-3">
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Conditions de paiement</label>
                                        <select
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.conditions_paiement ||
                                            "comptant"
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "conditions_paiement",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <option value="comptant">
                                            Comptant
                                          </option>
                                          <option value="30_jours">
                                            30 jours
                                          </option>
                                          <option value="60_jours">
                                            60 jours
                                          </option>
                                          <option value="90_jours">
                                            90 jours
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label>Délai de paiement (jours)</label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={
                                            newFournisseurDetails.delai_paiement ||
                                            0
                                          }
                                          onChange={(e) =>
                                            handleSupplierDetailChange(
                                              "delai_paiement",
                                              e.target.value,
                                            )
                                          }
                                          min="0"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex justify-content-end gap-2 mt-3">
                                    <button
                                      type="button"
                                      className="btn btn-secondary mr-2"
                                      onClick={handleCancelSupplierForm}
                                    >
                                      Annuler
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={handleSaveNewSupplier}
                                    >
                                      <i className="fa fa-save mr-2"></i>
                                      Enregistrer
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {/* Dropdown for search results */}
                            {showFournisseurDropdown && (
                              <div
                                className="border rounded shadow-sm fournisseur-dropdown"
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  backgroundColor: "white",
                                  zIndex: 1000,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }}
                              >
                                {isLoadingFournisseurs ? (
                                  <div className="p-3 text-center">
                                    <div
                                      className="spinner-border spinner-border-sm text-primary"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Chargement...
                                      </span>
                                    </div>
                                  </div>
                                ) : fournisseurList.length > 0 ? (
                                  <ul className="list-group list-group-flush">
                                    {fournisseurList.map((fournisseur) => (
                                      <li
                                        key={fournisseur.id}
                                        className="list-group-item list-group-item-action"
                                        onClick={() =>
                                          handleSelectFournisseur(fournisseur)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            <strong>{fournisseur.nom}</strong>
                                            {fournisseur.code && (
                                              <small className="text-muted ml-2">
                                                ({fournisseur.code})
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                ) : fournisseurSearch.trim() ? (
                                  <div className="p-3 text-center">
                                    <small className="text-muted">
                                      Aucun fournisseur trouvé.{" "}
                                      <button
                                        type="button"
                                        className="btn btn-link btn-sm p-0"
                                        onClick={handleAddNewFournisseur}
                                      >
                                        Créer "{fournisseurSearch}"
                                      </button>
                                    </small>
                                  </div>
                                ) : (
                                  <div className="p-3 text-center">
                                    <small className="text-muted">
                                      Tapez pour rechercher un fournisseur
                                    </small>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Selected supplier details */}
                          {selectedFournisseur && (
                            <div className="mt-3">
                              <div className="card bg-light">
                                <div className="card-body p-2">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <strong>Fournisseur sélectionné:</strong>{" "}
                                      {selectedFournisseur.nom}
                                      {selectedFournisseur.code && (
                                        <div>
                                          <small className="text-muted">
                                            Code: {selectedFournisseur.code}
                                          </small>
                                        </div>
                                      )}
                                      {selectedFournisseur.matricule_fiscal && (
                                        <div>
                                          <small>
                                            <i className="fa fa-id-card mr-1"></i>
                                            MF:{" "}
                                            {
                                              selectedFournisseur.matricule_fiscal
                                            }
                                          </small>
                                        </div>
                                      )}
                                      {selectedFournisseur.contact && (
                                        <div>
                                          <small>
                                            <i className="fa fa-user mr-1"></i>
                                            Contact:{" "}
                                            {selectedFournisseur.contact}
                                          </small>
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-md-6">
                                      {selectedFournisseur.telephone && (
                                        <div className="small">
                                          <i className="fa fa-phone mr-1"></i>
                                          {selectedFournisseur.telephone}
                                        </div>
                                      )}
                                      {selectedFournisseur.email && (
                                        <div className="small">
                                          <i className="fa fa-envelope mr-1"></i>
                                          {selectedFournisseur.email}
                                        </div>
                                      )}
                                      {selectedFournisseur.adresse && (
                                        <div className="small">
                                          <i className="fa fa-map-marker mr-1"></i>
                                          {selectedFournisseur.adresse}
                                        </div>
                                      )}
                                      {selectedFournisseur.conditions_paiement && (
                                        <div className="small">
                                          <i className="fa fa-clock-o mr-1"></i>
                                          {selectedFournisseur.conditions_paiement ===
                                          "comptant"
                                            ? "Comptant"
                                            : selectedFournisseur.conditions_paiement ===
                                                "30_jours"
                                              ? "30 jours"
                                              : selectedFournisseur.conditions_paiement ===
                                                  "60_jours"
                                                ? "60 jours"
                                                : selectedFournisseur.conditions_paiement ===
                                                    "90_jours"
                                                  ? "90 jours"
                                                  : ""}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Date d'achat</label>
                      <input
                        type="date"
                        className="form-control"
                        value={dateAchat}
                        onChange={(e) => setDateAchat(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>N° Facture</label>
                      <input
                        type="text"
                        className="form-control"
                        value={numeroFacture}
                        onChange={(e) => setNumeroFacture(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Notes</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Notes supplémentaires..."
                      />
                    </div>
                  </div>
                </div>

                <hr />

                <h5>Produits</h5>
                {produits?.map((produit, index) => (
                  <div key={index} className="row border p-3 mb-3">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Produit *</label>
                        <ProductSelector
                          organisation={usedOrganisations}
                          selectedProduct={
                            produit.menu_id
                              ? {
                                  _id: produit.menu_id,
                                  titre: produit.menu_name,
                                  reference: produit.menu_reference,
                                }
                              : null
                          }
                          onProductSelect={(product) =>
                            handleProductSelectorChange(index, product)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-1">
                      <div className="form-group">
                        <label>Qté *</label>
                        <input
                          type="number"
                          className="form-control"
                          min="0.001"
                          step="0.001"
                          value={produit.quantite}
                          onChange={(e) =>
                            handleProduitChange(
                              index,
                              "quantite",
                              e.target.value,
                            )
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Unité *</label>
                        <select
                          className="form-control"
                          value={produit.unite || "pcs"}
                          onChange={(e) =>
                            handleProduitChange(index, "unite", e.target.value)
                          }
                        >
                          {UNIT_OPTIONS.map((u) => (
                            <option key={u.value} value={u.value}>
                              {u.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Prix HT/{produit.unite || "pcs"} *</label>
                        <input
                          type="number"
                          step="0.001"
                          className="form-control"
                          min="0"
                          value={produit.prix_unitaire_ht}
                          onChange={(e) =>
                            handleProduitChange(
                              index,
                              "prix_unitaire_ht",
                              e.target.value,
                            )
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-1">
                      <div className="form-group">
                        <label>TVA %</label>
                        <select
                          className="form-control"
                          value={produit.taux_tva}
                          onChange={(e) =>
                            handleProduitChange(
                              index,
                              "taux_tva",
                              e.target.value,
                            )
                          }
                        >
                          <option value="0">0%</option>
                          <option value="7">7%</option>
                          <option value="19">19%</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Total TTC</label>
                        <input
                          type="number"
                          className="form-control"
                          step="0.001"
                          min="0"
                          value={produit.total_ttc || 0}
                          onChange={(e) =>
                            handleProduitChange(
                              index,
                              "total_ttc",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-1">
                      <div className="form-group">
                        <button
                          type="button"
                          style={{ marginTop: "46%" }}
                          className="btn btn-danger btn-sm"
                          onClick={() => removeProduit(index)}
                          disabled={produits.length === 1}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="btn btn-info mb-3"
                  onClick={addProduit}
                  style={{
                    width: "100%",
                  }}
                >
                  <i className="fa fa-plus"></i> Ajouter un produit
                </button>

                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Totaux</h5>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td>Total HT:</td>
                              <td className="text-right">
                                {totalHT.toFixed(3)}
                              </td>
                            </tr>
                            <tr>
                              <td>Total TVA:</td>
                              <td className="text-right">
                                {totalTVA.toFixed(3)}
                              </td>
                            </tr>
                            <tr className="font-weight-bold">
                              <td>Total TTC:</td>
                              <td className="text-right">
                                {totalTTC.toFixed(3)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-success">
                    <i className="fa fa-save"></i>{" "}
                    {editingAchat
                      ? "Mettre à jour l'achat"
                      : "Enregistrer l'achat"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Main Achat List component
// Main Achat List component
const AchatList = () => {
  const user = useUser();
  const infoUser = user.result;
  const [achats, setAchats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAchat, setEditingAchat] = useState(null);
  const [, , usedOrganisations] = useOrganisations();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedAchatForPayment, setSelectedAchatForPayment] = useState(null);
  const [showSupplierStatement, setShowSupplierStatement] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showPaymentHistory, setShowPaymentHistory] = useState(false);
  const [selectedAchatPayments, setSelectedAchatPayments] = useState(null);
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    date_debut: moment().startOf("day").format("YYYY-MM-DD"),
    date_fin: moment().endOf("day").format("YYYY-MM-DD"),
    fournisseur_id: "",
    statut: "",
    search: "",
  });
  const [filterFournisseurs, setFilterFournisseurs] = useState([]);

  const [valideFilter, setValideFilter] = useState("");

  console.log("achats", achats);
  useEffect(() => {
    if (!usedOrganisations) return;
    getFournisseurs(usedOrganisations, "")
      .then((res) => {
        if (res.data.success) setFilterFournisseurs(res.data.data || []);
      })
      .catch(() => {});
  }, [usedOrganisations]);

  const valideOptions = [
    { value: "", label: "Tous" },
    { value: "oui", label: "Cloturé" },
    { value: "non", label: "Non cloturé" },
  ];

  useEffect(() => {
    loadAchats();
  }, [usedOrganisations]);

  const loadAchats = async () => {
    try {
      setLoading(true);
      const params = {
        organisation_id: usedOrganisations,
        ...filters,
        valide: valideFilter,
      };

      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await getAchats(usedOrganisations, params);
      if (response.data.success) {
        setAchats(response.data.data.formattedAchats || []);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des achats");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleValideFilterChange = (value) => {
    setValideFilter(value);
  };

  const handleApplyFilters = () => {
    loadAchats();
  };

  const handleResetFilters = () => {
    setFilters({
      date_debut: "",
      date_fin: "",
      fournisseur_id: "",
      statut: "",
      search: "",
    });
    setValideFilter("");
  };

  const handleValidateAchat = async (achatId) => {
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Êtes-vous sûr de vouloir valider cet achat ? Cette action mettra à jour le stock.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, terminer",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const response = await validateAchat(achatId, "recu", infoUser.id);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Achat validé avec succès ! Stock mis à jour.",
          timer: 2000,
          showConfirmButton: false,
        });

        loadAchats();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: error.response?.data?.message || "Erreur lors de la validation",
      });
    }
  };

  const handleEditAchat = (achat) => {
    if (
      achat.valide === true ||
      achat.valide === "true" ||
      achat.valide === "oui"
    ) {
      toast.error("Impossible de modifier un achat déjà validé");
      return;
    }

    setEditingAchat(achat.id);
    setIsModalOpen(true);
  };

  const handleNewAchatSuccess = (newAchat) => {
    loadAchats();
  };

  const handleEditSuccess = (updatedAchat) => {
    toast.success("Achat mis à jour avec succès");
    loadAchats();
    setEditingAchat(null);
  };

  const handlePaymentSuccess = (paymentData) => {
    loadAchats(); // Refresh the list
    toast.success("Paiement enregistré avec succès");
  };

  const handleViewSupplierStatement = (fournisseurId, fournisseurName) => {
    setSelectedSupplier({ id: fournisseurId, name: fournisseurName });
    setShowSupplierStatement(true);
  };

  const handleViewPayments = async (achat) => {
    try {
      // Fetch payments for this achat
      const response = await getPaymentsByAchat(achat.id);
      if (response.data.success) {
        // Create a copy of achat with payments
        const achatWithPayments = {
          ...achat,
          paiements: response.data.data,
        };
        setSelectedAchatPayments(achatWithPayments);
        setShowPaymentHistory(true);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des paiements");
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("fr-FR");
  };

  const formatCurrency = (amount) => {
    return parseFloat(amount || 0).toFixed(3) + " TND";
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      brouillon: "secondary",
      en_attente: "warning",
      commande: "info",
      recu: "success",
      annule: "danger",
    };

    const badgeClass = statusMap[status] || "secondary";
    const statusText = {
      brouillon: "Brouillon",
      en_attente: "En attente",
      commande: "Commandé",
      recu: "Reçu",
      annule: "Annulé",
    };

    return (
      <span className={`badge badge-${badgeClass}`}>
        {statusText[status] || status}
      </span>
    );
  };

  const getValideBadge = (valide) => {
    if (valide === true || valide === "oui" || valide === "true") {
      return <span className="badge badge-success">Oui</span>;
    } else {
      return <span className="badge badge-secondary">Non</span>;
    }
  };

  const getPaymentStatusBadge = (soldeRestant) => {
    if (soldeRestant === 0) {
      return <span className="badge badge-success">Payé</span>;
    } else if (soldeRestant > 0) {
      return <span className="badge badge-warning">Partiel</span>;
    }
    return <span className="badge badge-secondary">-</span>;
  };

  // Calculate totals
  const totalAchats = achats.reduce((sum, a) => sum + (a.total_ttc || 0), 0);
  const totalRegle = achats.reduce((sum, a) => sum + (a.montant_regle || 0), 0);
  const totalRestant = achats.reduce(
    (sum, a) => sum + (a.solde_restant || 0),
    0,
  );
  const facturesEchues = achats.filter(
    (a) =>
      a.date_echeance &&
      new Date(a.date_echeance) < new Date() &&
      a.solde_restant > 0,
  ).length;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="box-title">Liste des Achats</h4>
                <div>
                  <button
                    className="btn btn-danger mr-1"
                    onClick={() => {
                      setEditingAchat(null);
                      setIsModalOpen(true);
                    }}
                  >
                    <i className="fa fa-plus mr-2"></i>
                    Ajouter un Achat
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={() => navigate("/providers")}
                  >
                    Fournisseurs
                  </button>
                </div>
              </div>

              {/* Summary Cards */}
              {/* <div className="row mb-4">
                <div className="col-md-3">
                  <div className="card bg-primary text-white">
                    <div className="card-body">
                      <h6>Total Achats</h6>
                      <h4>{formatCurrency(totalAchats)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-success text-white">
                    <div className="card-body">
                      <h6>Total Réglé</h6>
                      <h4>{formatCurrency(totalRegle)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-warning text-white">
                    <div className="card-body">
                      <h6>Reste à Payer</h6>
                      <h4>{formatCurrency(totalRestant)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-danger text-white">
                    <div className="card-body">
                      <h6>Factures Échues</h6>
                      <h4>{facturesEchues}</h4>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Filters Card */}
              <div className="card mb-4">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Date début</label>
                        <input
                          type="date"
                          className="form-control"
                          value={filters.date_debut}
                          onChange={(e) =>
                            handleFilterChange("date_debut", e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Date fin</label>
                        <input
                          type="date"
                          className="form-control"
                          value={filters.date_fin}
                          onChange={(e) =>
                            handleFilterChange("date_fin", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Fournisseur</label>
                        <select
                          className="form-control"
                          value={filters.fournisseur_id}
                          onChange={(e) =>
                            handleFilterChange("fournisseur_id", e.target.value)
                          }
                        >
                          <option value="">Tous les fournisseurs</option>
                          {filterFournisseurs.map((f) => (
                            <option key={f.id} value={f.id}>
                              {f.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Cloturé</label>
                        <select
                          className="form-control"
                          value={valideFilter}
                          onChange={(e) =>
                            handleValideFilterChange(e.target.value)
                          }
                        >
                          {valideOptions?.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Recherche (N° facture, fournisseur)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher..."
                          value={filters.search}
                          onChange={(e) =>
                            handleFilterChange("search", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    {/* Action buttons — kept inline with the filters, not on their own row */}
                    <div className="col-md-1">
                      <div className="form-group">
                        <label>&nbsp;</label>
                        <div className="d-flex" style={{ gap: "8px" }}>
                          <button
                            className="btn btn-primary"
                            onClick={handleApplyFilters}
                            title="Appliquer les filtres"
                          >
                            <i className="fa fa-filter"></i>
                          </button>
                          <button
                            className="btn btn-secondary"
                            onClick={handleResetFilters}
                            title="Réinitialiser les filtres"
                          >
                            <i className="fas fa-undo"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Chargement...</span>
                  </div>
                  <p className="mt-2">Chargement des achats...</p>
                </div>
              ) : achats.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fa fa-shopping-cart fa-3x text-muted mb-3"></i>
                  <h5>Aucun achat trouvé</h5>
                  <p className="text-muted">
                    Commencez par ajouter votre premier achat.
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>N° Facture</th>
                        <th>Date</th>
                        <th>Fournisseur</th>
                        <th>Total TTC</th>
                        <th>Réglé</th>
                        <th>Reste</th>
                        <th>Statut Paiement</th>
                        <th>Cloturé</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {achats?.map((achat) => (
                        <tr key={achat.id}>
                          <td>
                            <strong>{achat.numero_facture}</strong>
                          </td>
                          <td>{formatDate(achat.date_achat)}</td>
                          <td>
                            <div>
                              <strong>
                                {achat.fournisseur_details?.nom || "N/A"}
                              </strong>
                              {achat.fournisseur_details?.matricule_fiscal && (
                                <>
                                  {" "}
                                  <br />
                                  <small className="text-muted">
                                    MF:{" "}
                                    {achat.fournisseur_details.matricule_fiscal}
                                  </small>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="font-weight-bold">
                            {formatCurrency(achat.total_ttc)}
                          </td>
                          <td className="text-success">
                            {formatCurrency(achat.montant_regle || 0)}
                          </td>
                          <td
                            className={
                              achat.solde_restant > 0
                                ? "text-danger font-weight-bold"
                                : "text-success"
                            }
                          >
                            {formatCurrency(achat.solde_restant || 0)}
                          </td>
                          <td>{getPaymentStatusBadge(achat.solde_restant)}</td>
                          {/* <td>
                            {achat.date_echeance && (
                              <>
                                {formatDate(achat.date_echeance)}
                                {new Date(achat.date_echeance) < new Date() &&
                                  achat.solde_restant > 0 && (
                                    <>
                                      <br />
                                      <span className="badge badge-danger">
                                        En retard
                                      </span>
                                    </>
                                  )}
                              </>
                            )}
                          </td> */}
                          <td>{getValideBadge(achat.valide)}</td>
                          <td>
                            <div
                              className="btn-group"
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "5px",
                              }}
                            >
                              {/* Validation button - only if not validated */}
                              {(!achat.valide ||
                                achat.valide === false ||
                                achat.valide === "non" ||
                                achat.valide === "false") && (
                                <>
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={() =>
                                      handleValidateAchat(achat.id)
                                    }
                                    title="Valider l'achat (met à jour le stock)"
                                  >
                                    <i className="fa fa-check"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => handleEditAchat(achat)}
                                    title="Éditer"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                </>
                              )}

                              {/* Payment button - show for validated purchases with remaining balance */}
                              {achat.valide && achat.solde_restant > 0 && (
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => {
                                    setSelectedAchatForPayment(achat);
                                    setShowPaymentModal(true);
                                  }}
                                  title={`Payer ${formatCurrency(achat.solde_restant)}`}
                                >
                                  <i className="fa-solid fa-hand-holding-dollar"></i>
                                </button>
                              )}

                              {/* Payment History button - show if there are payments */}
                              {achat.montant_regle > 0 && (
                                <button
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => handleViewPayments(achat)}
                                  title="Voir l'historique des paiements"
                                >
                                  <i className="fa fa-history"></i>
                                </button>
                              )}

                              {/* Invoice button */}
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={async () => {
                                  try {
                                    const response = await generateFacturePDF(
                                      achat.id,
                                    );
                                    const pdfBlob = new Blob([response.data], {
                                      type: "application/pdf",
                                    });
                                    const pdfUrl = URL.createObjectURL(pdfBlob);
                                    window.open(pdfUrl, "_blank");
                                    setTimeout(
                                      () => URL.revokeObjectURL(pdfUrl),
                                      100,
                                    );
                                  } catch (error) {
                                    console.error(
                                      "Error loading invoice:",
                                      error,
                                    );
                                    toast.error(
                                      "Erreur lors du chargement de la facture",
                                    );
                                  }
                                }}
                                title="Voir la facture"
                              >
                                <i className="fa fa-file-pdf-o"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal for adding/editing purchase */}
      <AddAchatModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingAchat(null);
        }}
        onSuccess={handleNewAchatSuccess}
        onEditSuccess={handleEditSuccess}
        editingAchat={editingAchat}
      />

      {/* Payment Modal */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => {
          setShowPaymentModal(false);
          setSelectedAchatForPayment(null);
        }}
        achat={selectedAchatForPayment}
        onSuccess={(paymentData) => {
          loadAchats(); // Refresh the list
          toast.success("Paiement enregistré avec succès");
        }}
      />

      {/* Supplier Statement Modal */}
      {showSupplierStatement && (
        <SupplierStatement
          fournisseurId={selectedSupplier?.id}
          fournisseurName={selectedSupplier?.name}
          onClose={() => {
            setShowSupplierStatement(false);
            setSelectedSupplier(null);
          }}
        />
      )}

      {/* Payment History Modal */}
      {showPaymentHistory && selectedAchatPayments && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Historique des Paiements - Facture{" "}
                  {selectedAchatPayments.numero_facture}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowPaymentHistory(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <strong>Fournisseur:</strong>{" "}
                  {selectedAchatPayments.fournisseur_details?.nom}
                </div>
                <div className="mb-3">
                  <strong>Total TTC:</strong>{" "}
                  {formatCurrency(selectedAchatPayments.total_ttc)}
                </div>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      {" "}
                      <th>Code</th>
                      <th>Date</th>
                      <th>Mode</th>
                      <th>Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedAchatPayments.paiements?.map((payment, index) => (
                      <tr key={index}>
                        <td>{payment.code || "-"}</td>
                        <td>{formatDate(payment.date_paiement)}</td>
                        <td>{payment.mode_paiement}</td>
                        <td className="text-success">
                          {formatCurrency(payment.montant)}
                        </td>
                      </tr>
                    ))}
                    {(!selectedAchatPayments.paiements ||
                      selectedAchatPayments.paiements.length === 0) && (
                      <tr>
                        <td colSpan="4" className="text-center">
                          Aucun paiement enregistré
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colSpan="3">Total Réglé</th>
                      <th className="text-success">
                        {formatCurrency(
                          selectedAchatPayments.montant_regle || 0,
                        )}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan="3">Reste à Payer</th>
                      <th className="text-danger">
                        {formatCurrency(
                          selectedAchatPayments.solde_restant || 0,
                        )}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPaymentHistory(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AchatList;
